import React from 'react'
import { useLocation } from 'react-router-dom'
import { Box } from '@material-ui/core'
import SystemsApproval from './SystemsApproval'
import SystemAddition from './SystemAddition'

function SystemsEnrollment() {
  const location = useLocation()
  return (
    // <SystemsApproval />
    <SystemAddition />
  )
}

export default SystemsEnrollment